(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
  var checkbox = document.getElementById('signup-checkbox-footer');
  var submitButton = document.getElementById('FooterSubscribe');

  if (checkbox && submitButton) {
    checkbox.removeEventListener('change', toggleSubmitButton);
    checkbox.addEventListener('change', toggleSubmitButton);

    submitButton.disabled = !checkbox.checked;
  }
}

function toggleSubmitButton() {
  var submitButton = document.getElementById('FooterSubscribe');
  if (submitButton) {
    submitButton.disabled = !this.checked;
  }
}

document.addEventListener('DOMContentLoaded', attachCheckboxListener);
document.addEventListener('shopify:section:select', attachCheckboxListener);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});

function initMegaCollectionTabs() {
  const roots = document.querySelectorAll('[data-mega-collection-root]');
  if (!roots.length) return;

  roots.forEach((root) => {
    if (root.dataset.tabsInitialized === 'true') return;
    root.dataset.tabsInitialized = 'true';

    root.querySelectorAll('[data-mega-collection-tab]').forEach((tabButton) => {
      tabButton.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = tabButton.getAttribute('data-target');
        if (!targetId) return;

        root.querySelectorAll('[data-mega-collection-tab]').forEach((button) => {
          button.classList.remove('is-active');
        });
        tabButton.classList.add('is-active');

        root.querySelectorAll('[data-mega-collection-panel]').forEach((panel) => {
          panel.classList.toggle('hidden', panel.id !== targetId);
        });
      });
    });
  });
}

function initDesktopClickSubmenus() {
  const desktopMedia = window.matchMedia('(min-width: 990px)');
  const navRoots = document.querySelectorAll('.main-navigation, .main-navigation-mega');
  if (!navRoots.length) return;

  const getDirectSubmenu = (listItem) => {
    const details = listItem.querySelector(':scope > details');
    if (details) {
      return details.querySelector(':scope > .navigation-submenu');
    }
    return listItem.querySelector(':scope > .navigation-submenu');
  };

  const closeItem = (listItem) => {
    listItem.classList.remove('is-open');
    const trigger = listItem.querySelector(':scope > .nav-menu-item');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    const details = listItem.querySelector(':scope > details');
    if (details) details.open = false;

    listItem.querySelectorAll('li.is-open').forEach((childItem) => {
      childItem.classList.remove('is-open');
      const childTrigger = childItem.querySelector(':scope > .nav-menu-item');
      if (childTrigger) childTrigger.setAttribute('aria-expanded', 'false');
      const childDetails = childItem.querySelector(':scope > details');
      if (childDetails) childDetails.open = false;
    });
  };

  const closeSiblings = (listItem) => {
    const parent = listItem.parentElement;
    if (!parent) return;
    parent.querySelectorAll(':scope > li.is-open').forEach((sibling) => {
      if (sibling !== listItem) closeItem(sibling);
    });
  };

  const closeAll = () => {
    document.querySelectorAll('.main-navigation li.is-open, .main-navigation-mega li.is-open').forEach((openItem) => {
      closeItem(openItem);
    });
  };

  navRoots.forEach((navRoot) => {
    if (navRoot.dataset.clickSubmenuInit === 'true') return;
    navRoot.dataset.clickSubmenuInit = 'true';

    navRoot.addEventListener('click', (event) => {
      if (!desktopMedia.matches) return;

      const trigger = event.target.closest('.nav-menu-item');
      if (!trigger || !navRoot.contains(trigger)) return;

      const listItem = trigger.closest('li');
      if (!listItem) return;

      const submenu = getDirectSubmenu(listItem);
      if (!submenu) return;

      event.preventDefault();
      event.stopPropagation();

      const isOpen = listItem.classList.contains('is-open');
      closeSiblings(listItem);

      if (isOpen) {
        closeItem(listItem);
        return;
      }

      listItem.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      const details = listItem.querySelector(':scope > details');
      if (details) details.open = true;
    });
  });

  if (!window.__headerClickSubmenuBound) {
    window.__headerClickSubmenuBound = true;

    document.addEventListener('click', (event) => {
      if (!desktopMedia.matches) return;
      if (event.target.closest('.main-navigation, .main-navigation-mega')) return;
      closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });

    desktopMedia.addEventListener('change', (event) => {
      if (!event.matches) closeAll();
    });
  }
}

initMegaCollectionTabs();
initDesktopClickSubmenus();

document.addEventListener('shopify:section:load', () => {
  initMegaCollectionTabs();
  initDesktopClickSubmenus();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tob-products-slide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /**
     * Dots match SliderComponent pages (global.js): totalPages = items - slidesPerPage + 1,
     * not one dot per product. Dots are built in JS after initPages(). Clicks scroll to the
     * first slide index for that page (same geometry as prev/next).
     */
    function syncDots(root, activeZeroBased) {
      var dots = root.querySelectorAll('.tob-products-slide__dot');
      if (!dots.length) return;
      var maxIdx = Math.max(0, dots.length - 1);
      var i = Math.min(Math.max(0, activeZeroBased), maxIdx);
      dots.forEach(function (dot, idx) {
        var on = idx === i;
        dot.classList.toggle('tob-products-slide__dot--active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function syncDotsFromSliderComponent(sc, root) {
      var dots = root.querySelectorAll('.tob-products-slide__dot');
      if (!dots.length) return;
      var total =
        typeof sc.totalPages === 'number' && sc.totalPages >= 1 ? sc.totalPages : dots.length;
      var page =
        typeof sc.currentPage === 'number' && sc.currentPage >= 1 ? sc.currentPage : 1;
      syncDots(root, Math.min(page - 1, total - 1, dots.length - 1));
    }

    function buildDots(sc, root) {
      var dotsRoot = root.querySelector('[data-tob-dots]');
      if (!dotsRoot || !sc.slider) return;

      var rawTotal = typeof sc.totalPages === 'number' ? sc.totalPages : 0;
      var total = Math.floor(rawTotal);
      if (!isFinite(total) || total < 1) total = 1;
      var items = sc.sliderItemsToShow;
      if (!items || !items.length) {
        dotsRoot.innerHTML = '';
        return;
      }

      var labelBase = root.getAttribute('data-slide-page-label') || 'Slide';
      var labelOf = root.getAttribute('data-slide-of') || 'of';

      dotsRoot.innerHTML = '';
      for (var p = 1; p <= total; p++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tob-products-slide__dot' + (p === 1 ? ' tob-products-slide__dot--active' : '');
        btn.setAttribute('data-page-index', String(p - 1));
        btn.setAttribute('aria-label', labelBase + ' ' + p + ' ' + labelOf + ' ' + total);
        btn.setAttribute('aria-current', p === 1 ? 'true' : 'false');
        dotsRoot.appendChild(btn);
      }
    }

    function scrollToPage(sc, pageIndexZeroBased) {
      var slider = sc.slider;
      var items = sc.sliderItemsToShow;
      if (!slider || !items || !items.length) return;
      var idx = Math.min(Math.max(0, pageIndexZeroBased), items.length - 1);
      var target = items[idx];
      if (!target) return;
      var left = target.offsetLeft;
      slider.scrollTo({ left: left, behavior: 'smooth' });
    }

    function bindTobProductsSlide(root, sc) {
      var slider = sc.slider;
      var dotsRoot = root.querySelector('[data-tob-dots]');
      if (!dotsRoot) return;

      var resizeDebounce = null;
      function rebuildDotsAndSync() {
        if (typeof sc.initPages === 'function') sc.initPages();
        buildDots(sc, root);
        requestAnimationFrame(function () {
          syncDotsFromSliderComponent(sc, root);
        });
      }

      function scheduleRebuildDots() {
        if (resizeDebounce) cancelAnimationFrame(resizeDebounce);
        resizeDebounce = requestAnimationFrame(function () {
          resizeDebounce = null;
          rebuildDotsAndSync();
        });
      }

      sc.addEventListener('slideChanged', function (e) {
        var page = e.detail && e.detail.currentPage;
        if (typeof page !== 'number' || page < 1) return;
        syncDotsFromSliderComponent(sc, root);
      });

      var scrollTicking = false;
      slider.addEventListener(
        'scroll',
        function () {
          if (scrollTicking) return;
          scrollTicking = true;
          requestAnimationFrame(function () {
            scrollTicking = false;
            syncDotsFromSliderComponent(sc, root);
          });
        },
        { passive: true }
      );

      dotsRoot.addEventListener('click', function (e) {
        var btn = e.target.closest('.tob-products-slide__dot');
        if (!btn || !dotsRoot.contains(btn)) return;
        var pageIdx = parseInt(btn.getAttribute('data-page-index'), 10);
        if (isNaN(pageIdx)) return;
        scrollToPage(sc, pageIdx);
      });

      var ro = new ResizeObserver(function () {
        scheduleRebuildDots();
      });
      ro.observe(slider);

      rebuildDotsAndSync();
    }

    function initTobProductsSlide(root) {
      if (root.dataset.tobInitialized === 'true') return;
      var sc = root.querySelector('slider-component');
      console.log("slider-component : " + sc);
      var dotsRoot = root.querySelector('[data-tob-dots]');
      if (!sc || !dotsRoot) {
        root.dataset.tobInitialized = 'true';
        return;
      }

      function markReadyAndBind() {
        if (root.dataset.tobInitialized === 'true') return;
        if (!sc.slider || !sc.nextButton) return false;
        if (typeof sc.initPages === 'function') sc.initPages();
        var tp = sc.totalPages;
        if (
          typeof tp !== 'number' ||
          !isFinite(tp) ||
          tp < 1 ||
          !sc.sliderItemsToShow ||
          !sc.sliderItemsToShow.length
        ) {
          return false;
        }
        bindTobProductsSlide(root, sc);
        root.dataset.tobInitialized = 'true';
        return true;
      }

      customElements.whenDefined('slider-component').then(function () {
        var attempts = 0;

          function tick() {
            if (markReadyAndBind()) return;

            attempts += 1;

            if (attempts > 80) {
              console.log('slider init failed');
              return;
            }

            setTimeout(tick, 100);
          }

          tick();
      });
    }

    function scan(container) {
      (container || document).querySelectorAll('[data-tob-products-slide]').forEach(initTobProductsSlide);
    }

    if (!window.__tobProductsSlideListeners) {
      window.__tobProductsSlideListeners = true;
      document.addEventListener('shopify:section:load', function (event) {
        if (event.target && event.target.querySelectorAll) scan(event.target);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scan(document);
      });
    } else {
      scan(document);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
